import { Link as RouterLink } from "react-router-dom"

import { SearchInput as UiSearchInput, APPBAR_HEIGHT, SIDEBAR_WIDTH, styled, APPBAR_WITHOUT_MODULES_HEIGHT } from "@l2r-front/l2r-ui"

import { AppBar as AppBarComponent } from "../../components/AppBar"
import { SEARCH_INPUT_WIDTH } from "../../constants/layout"
import { AppSelector as L2rAppSelector } from "../../containers/AppSelector"
import { ModuleSelector as L2rModuleSelector } from "../../containers/ModuleSelector"
import { NetworkSelector as L2rNetworkSelector } from "../../containers/NetworkSelector"

export const AppBar = styled(AppBarComponent)(({ theme }) => ({
    zIndex: theme.zIndex.drawer + 2,
}))

export const ChildrenWrapper = styled("div", { shouldForwardProp: (prop) => prop !== "hasModuleTabs" })(({ hasModuleTabs }) => ({
    boxSizing: "border-box",
    display: "flex",
    height: "100%",
    justifyContent: "space-around",
    paddingTop: hasModuleTabs ? APPBAR_HEIGHT : APPBAR_WITHOUT_MODULES_HEIGHT,
    position: "relative",
    width: "100%",
}))

export const ChildrenWrapperWithoutAppBar = styled(ChildrenWrapper)({
    paddingTop: 0,
})

export const Link = styled(RouterLink)({
    alignItems: "center",
    display: "flex",
    height: "100%",
})
export const WrapperRight = styled("div")(({ theme }) => ({
    alignItems: "center",
    display: "flex",
    height: "100%",
    position: "relative",
    width: `calc(100% - ${SIDEBAR_WIDTH}px + ${theme.spacing(9)})`,
}))

export const SearchInput = styled(UiSearchInput)(({ theme }) => ({
    margin: theme.spacing(1, 2, 1, 2),
    width: SEARCH_INPUT_WIDTH,
}))

export const WrapperLeft = styled("div")(({ theme }) => ({
    alignItems: "center",
    display: "flex",
    height: "100%",
    position: "relative",
    width: `calc(${SIDEBAR_WIDTH}px - ${theme.spacing(9)})`,
}))

export const NetworkSelector = styled(L2rNetworkSelector)({
    marginLeft: "auto",
})

export const AppSelector = styled(L2rAppSelector)({
    flexGrow: 1,
})

export const ModuleSelector = styled(L2rModuleSelector)({
    width: "100%",
})

export const Logo = styled("img")(() => ({
    height: 36,
}))

export const SmallLogo = styled("img")(() => ({
    height: 30,
}))